"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreatedReviewOfProductConfig = void 0;

var _ReviewOfProductReducer = _interopRequireDefault(require("../ReviewOfProductReducer"));

var _ReviewOfProductActions = _interopRequireDefault(require("../ReviewOfProductActions"));

var _CreatedReviewOfProductContainer = _interopRequireDefault(require("./CreatedReviewOfProductContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreatedReviewOfProductConfig = {
  auth: ['user'],
  routes: [{
    component: _CreatedReviewOfProductContainer.default,
    path: '/created-product-reviews'
  }],
  reducer: _ReviewOfProductReducer.default,
  actions: _ReviewOfProductActions.default
};
exports.CreatedReviewOfProductConfig = CreatedReviewOfProductConfig;